import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { findDocumentStatusTranslationId } from '@synergy/utils';

import { PoolChipList } from '../chip-list';
import { useFilter } from './context/filter-context';

interface FilterChipProps {
    withinSubToolbar?: boolean;
}

export const FilterChips = (props: FilterChipProps) => {
    const { filter, updateFilter, getDisplayValue } = useFilter();

    const getPropertyPath = (items: string[]) => items.join('.');

    const handleFilterChipDelete = (propertyPaths: string | string[]) => {
        const propertyPathsArray = Array.isArray(propertyPaths) ? propertyPaths : [propertyPaths];
        const nextFilter = new URLSearchParams();
        Array.from(filter.entries())
            .filter(entry => !propertyPathsArray.includes(getPropertyPath(entry)))
            .forEach(([key, value]) => nextFilter.append(key, value));
        updateFilter(nextFilter);
    };

    /**
     * A document status is set by the sub-views of the navigation rather than by
     * a filter component, so nothing registers a label for it — and the chip
     * showed the raw value where it should name the status.
     */
    const labelOf = (key: string, value: string): ReactNode => {
        const statusId = findDocumentStatusTranslationId(value);

        return statusId ? <FormattedMessage id={statusId} /> : getDisplayValue(key, value);
    };

    const getChips = () => {
        const ignoredFilterKeys = [
            'sort',
            'order',
            'search',
            'limit',
            'page',
            'pageSize',
            'currency',
            'locale',
            'invoiceNumberSequenceId',
        ];

        const filterEntryArray = Array.from(filter.entries());
        const result = filterEntryArray
            .filter(([key]) => !ignoredFilterKeys.includes(key))
            .map(([key, value]) => ({
                propertyPaths: getPropertyPath([key, value]),
                id: 'app.filter.' + key,
                value: labelOf(key, value),
            }));
        return result;
    };

    return (
        <PoolChipList
            chips={getChips()}
            onChipDelete={handleFilterChipDelete}
            styleType={props.withinSubToolbar ? 'withinSubToolbar' : 'legacy'}
        />
    );
};
